import * as React from 'react';
export const Linkedin = (
  props: React.SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M5.862 8.324V22.5H1.028V8.324h4.834zm.308-4.378c.015 1.36-1.04 2.446-2.725 2.446h-.029C1.79 6.392.75 5.305.75 3.946.75 2.56 1.834 1.5 3.475 1.5c1.655 0 2.68 1.059 2.695 2.446zm7.178 6.393c.636-.971 1.783-2.344 4.35-2.344 3.179 0 5.552 2.03 5.552 6.38V22.5h-4.82v-7.582c0-1.902-.703-3.204-2.446-3.204-1.333 0-2.124.872-2.475 1.716-.117.315-.161.73-.161 1.16v7.91h-4.82c.059-12.846 0-14.176 0-14.176h4.82v2.014z" />
  </svg>
);
